
import { cn } from "@/lib/utils";

export function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">About Us</h2>
            <div className="space-y-4 text-muted-foreground">
              <p>
                AVON BEARINGS is the best bearing shop in Wankaner and a leading bearing dealer serving Morbi, Rajkot, and all of Gujarat. For over two decades, we have been a trusted provider of high-quality precision bearings for automotive, industrial, machinery, and agricultural applications.
              </p>
              <p>
                As authorized dealers of SKF, FAG, NBC, NSK, Timken, NTN, Koyo, INA, Nachi, RHP, THK, Hiwin, and Kluber, we deliver exceptional bearing products that meet the highest standards of quality, reliability, and performance.
              </p>
              <p>
                Located at 3, Jadeshwar Chamber, 8-A National Highway, Wankaner (Dist. Morbi-363622), our team of experienced engineers and industry specialists provides expert guidance to help you select the perfect bearing solution for your specific application requirements. We proudly serve customers across Wankaner, Morbi, Rajkot, Surendranagar, Jamnagar, and beyond.
              </p>
            </div>
          </div>
          <div>
            <div className="rounded-lg overflow-hidden shadow-lg border border-muted bg-background/50">
              <img
                src="/images/about_us_industrial.png"
                alt="AVON BEARINGS state-of-the-art industrial bearing manufacturing and storage facility"
                className="w-full h-auto object-cover aspect-video sm:aspect-square md:aspect-[4/3]"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
